import { BrowserRouter } from 'react-router-dom';
import Router from './components/Router';
import './styles/main.scss';
import { Box, ThemeProvider } from '@ace-clublabs/shared-component-library';
import LogCannon from '@ace-clublabs/log-cannon';
import { TeamValue, WorkloadValue } from '@ace-clublabs/aws-tags';
import { version } from 'process';
import { useEffect } from 'react';
import { useGlobalState } from './shared/state';

export const App = () => {
  window.global ||= window;
  const base_url = (global as any).public_url || '/payments/manage-autopay';
  const [, setSessionId] = useGlobalState('sessionId');

  const apiKey = import.meta.env.VITE_LOG_CANNON_API_KEY;

  LogCannon.init(apiKey, {
    team: TeamValue.Payments,
    component: 'manage-autopay',
    workload: WorkloadValue.Payments,
    runtime: 'nodejs',
    runtimeVersion: version,
  } as any);

  useEffect(() => {
    const sessionId = LogCannon.getSessionId();
    setSessionId(sessionId);
  }, []);

  return (
    <>
      <BrowserRouter basename={base_url}>
        <ThemeProvider>
          <Box className="appContainer">
            <Router />
          </Box>
        </ThemeProvider>
      </BrowserRouter>
    </>
  );
};

export default App;
